import React from "react";

export type ToastItem = {
    id: string;
    type: "success" | "error" | "info";
    title?: string;
    message: string;
};

export default function ToastHost({
    items,
    onDismiss,
}: {
    items: ToastItem[];
    onDismiss: (id: string) => void;
}) {
    return (
        <div
            style={{
                position: "fixed",
                right: 16,
                bottom: 16,
                display: "grid",
                gap: 10,
                zIndex: 10000,
                width: "min(380px, 92vw)",
            }}
        >
            {items.map((t) => (
                <div
                    key={t.id}
                    style={{
                        borderRadius: 12,
                        padding: 12,
                        border: "1px solid rgba(0,0,0,0.12)",
                        background: "#fff",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
                        <div style={{ fontWeight: 800 }}>
                            {t.title ??
                                (t.type === "success"
                                    ? "Succes"
                                    : t.type === "error"
                                        ? "Fejl"
                                        : "Info")}
                        </div>
                        <button className="cancel-btn" onClick={() => onDismiss(t.id)}>
                            Luk
                        </button>
                    </div>

                    <div style={{ marginTop: 6, color: "#333", lineHeight: 1.35 }}>{t.message}</div>

                    <div style={{ marginTop: 8, fontSize: 12, color: "#666" }}>
                        {t.type === "success"
                            ? "✅"
                            : t.type === "error"
                                ? "⛔"
                                : "ℹ️"}{" "}
                        {t.type.toUpperCase()}
                    </div>
                </div>
            ))}
        </div>
    );
}